<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 0C16.299 0 21 4.701 21 10.5S16.299 21 10.5 21 0 16.299 0 10.5 4.701 0 10.5 0zm0 2a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM17 18.265L18.265 17 24 22.736 22.735 24 17 18.265z" fill-rule="nonzero" fill="currentColor"/>
</svg>
